import React from 'react';
import * as S from './styled';
export const ProductStockVariantsTooltipContent = ({ variants, }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Header, null,
            React.createElement(S.Label, null, "Variant"),
            React.createElement(S.Label, null, "Stock")),
        React.createElement(S.Content, null, variants?.map((stockVariant) => (React.createElement(S.Variant, { key: stockVariant.variant },
            React.createElement(S.Name, null, stockVariant.variant),
            React.createElement(S.StockCount, null, stockVariant.stock?.type === 'UNLIMITED' ? 'Unlimited' : stockVariant.stock.quantity)))))));
};
